import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mt-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.ui-component.html',
  styleUrl: './loader.ui-component.scss',
})
export class LoaderUiComponent {}
